/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneChrome
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneChrome = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped.call(this);
};
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped,
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneChrome,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneChrome"
                 );


